import React from 'react';
import { getContactCopy } from './contactCopy';

type Props = {
  lang: 'cs' | 'en';
  langLabel: string;
};

/** Shared marketing footer for public pages (login, contact, …). */
const MarketingFooter: React.FC<Props> = ({ lang, langLabel }) => {
  const c = getContactCopy(lang);

  return (
    <footer
      style={{
        background: '#fff',
        borderTop: '1px solid #EDF0F5',
        padding: 'clamp(44px,7vw,64px) 20px 32px',
      }}
    >
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div
          data-footer-grid
          style={{ display: 'grid', gridTemplateColumns: '1.6fr 1fr 1fr 1fr 1fr', gap: 40 }}
        >
          <div>
            <img
              src="/home/ompli-logo-blue.png"
              alt="Ompli"
              style={{ height: 24, width: 'auto', display: 'block' }}
            />
            <p
              style={{
                margin: '16px 0 0',
                fontSize: 15,
                lineHeight: 1.6,
                color: '#6B7280',
                maxWidth: 260,
                textWrap: 'pretty',
              }}
            >
              {c.footerTagline}
            </p>
            <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
              <a
                href="#li"
                aria-label="LinkedIn"
                className="home-social"
                style={{
                  width: 34,
                  height: 34,
                  borderRadius: 10,
                  background: '#F7F8FA',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#6B7280',
                  transition: 'all 150ms ease-out',
                }}
              >
                <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM2.75 9.25h4.46V21H2.75V9.25zm7.02 0h4.27v1.6h.06c.6-1.07 2.06-1.94 3.79-1.94 3.24 0 4.36 1.94 4.36 5.35V21h-4.46v-5.72c0-1.44-.52-2.42-1.8-2.42-1.05 0-1.67.71-1.94 1.4-.1.24-.13.58-.13.92V21H9.77s.06-10.63 0-11.75z" />
                </svg>
              </a>
              <a
                href="#fb"
                aria-label="Facebook"
                className="home-social"
                style={{
                  width: 34,
                  height: 34,
                  borderRadius: 10,
                  background: '#F7F8FA',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#6B7280',
                  transition: 'all 150ms ease-out',
                }}
              >
                <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5.02 3.66 9.18 8.44 9.94v-7.03H7.9v-2.91h2.54V9.85c0-2.52 1.49-3.91 3.77-3.91 1.09 0 2.24.2 2.24.2v2.47h-1.26c-1.24 0-1.63.78-1.63 1.57v1.88h2.78l-.45 2.91h-2.33V22c4.78-.76 8.44-4.92 8.44-9.94z" />
                </svg>
              </a>
              <a
                href="#ig"
                aria-label="Instagram"
                className="home-social"
                style={{
                  width: 34,
                  height: 34,
                  borderRadius: 10,
                  background: '#F7F8FA',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#6B7280',
                  transition: 'all 150ms ease-out',
                }}
              >
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  aria-hidden="true"
                >
                  <rect x="3" y="3" width="18" height="18" rx="5" />
                  <circle cx="12" cy="12" r="4" />
                  <circle cx="17.3" cy="6.7" r="1.1" fill="currentColor" stroke="none" />
                </svg>
              </a>
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div style={{ fontSize: 14, fontWeight: 600, color: '#111827' }}>{c.footerProduct}</div>
            <a href="/#funkce" className="home-footer-link" style={{ fontSize: 15, color: '#6B7280' }}>
              {c.footerShifts}
            </a>
            <a href="/#funkce" className="home-footer-link" style={{ fontSize: 15, color: '#6B7280' }}>
              {c.footerAttendance}
            </a>
            <a href="/#funkce" className="home-footer-link" style={{ fontSize: 15, color: '#6B7280' }}>
              {c.footerContracts}
            </a>
            <a href="/#funkce" className="home-footer-link" style={{ fontSize: 15, color: '#6B7280' }}>
              {c.footerHiring}
            </a>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div style={{ fontSize: 14, fontWeight: 600, color: '#111827' }}>{c.footerCompany}</div>
            <a href="/o-nas" className="home-footer-link" style={{ fontSize: 15, color: '#6B7280' }}>
              {c.footerAbout}
            </a>
            <a href="#kariera" className="home-footer-link" style={{ fontSize: 15, color: '#6B7280' }}>
              {c.footerCareers}
            </a>
            <a href="/blog" className="home-footer-link" style={{ fontSize: 15, color: '#6B7280' }}>
              {c.footerBlog}
            </a>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div style={{ fontSize: 14, fontWeight: 600, color: '#111827' }}>{c.footerSupport}</div>
            <a href="/docs" className="home-footer-link" style={{ fontSize: 15, color: '#6B7280' }}>
              {c.footerHelp}
            </a>
            <a href="/kontakt" className="home-footer-link" style={{ fontSize: 15, color: '#6B7280' }}>
              {c.footerContact}
            </a>
            <a href="#status" className="home-footer-link" style={{ fontSize: 15, color: '#6B7280' }}>
              {c.footerStatus}
            </a>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div style={{ fontSize: 14, fontWeight: 600, color: '#111827' }}>{c.footerLegal}</div>
            <a href="#gdpr" className="home-footer-link" style={{ fontSize: 15, color: '#6B7280' }}>
              {c.footerGdpr}
            </a>
            <a href="#podminky" className="home-footer-link" style={{ fontSize: 15, color: '#6B7280' }}>
              {c.footerTerms}
            </a>
            <a href="#cookies" className="home-footer-link" style={{ fontSize: 15, color: '#6B7280' }}>
              {c.footerCookies}
            </a>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 24,
            flexWrap: 'wrap',
            marginTop: 48,
            paddingTop: 24,
            borderTop: '1px solid #EDF0F5',
          }}
        >
          <span style={{ fontSize: 14, color: '#6B7280' }}>© 2026 Ompli s.r.o.</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <span style={{ fontSize: 14, color: '#6B7280' }}>{langLabel} · CZK</span>
            <a href="#privacy" className="home-footer-link" style={{ fontSize: 14, color: '#6B7280' }}>
              {c.footerPrivacy}
            </a>
            <a href="#terms" className="home-footer-link" style={{ fontSize: 14, color: '#6B7280' }}>
              {c.footerTermsShort}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default MarketingFooter;
